import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Domain, Home, Orientation, Thematic, PreProcedure } from "./screens";
import { ThemeProvider } from "styled-components";
import { GlobalStyle } from "./styled-components";
import theme from "./theme";
import domainData from "./data/domains-data.json";
import steps from "./data/steps.json";
import stepsAlert from "./data/stepsAlert.json";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/administration"
            element={<Domain data={domainData[0]} steps={steps} />}
          />
          <Route
            path="/discrimination"
            element={<Domain data={domainData[1]} steps={steps} />}
          />
          <Route
            path="/enfance"
            element={<Domain data={domainData[2]} steps={steps} />}
          />
          <Route
            path="/deontologie"
            element={<Domain data={domainData[3]} steps={steps} />}
          />
          <Route
            path="/autre"
            element={<Domain steps={steps} data={domainData[5]} />}
          />
          <Route
            path="/:domain/:exemple"
            element={<Orientation data={domainData} steps={steps} />}
          />
          <Route
            path="/:domain/demarches/:exemple"
            element={<PreProcedure data={domainData} steps={steps} />}
          />
          <Route
            path="/alerte"
            element={<Domain data={domainData[4]} steps={stepsAlert} />}
          />
          <Route
            path="/alerte/:theme"
            element={<Thematic data={domainData[4]} steps={stepsAlert} />}
          />
          <Route
            path="/:domain/:theme/orientation"
            element={<Orientation data={domainData} steps={stepsAlert} />}
          />
          <Route
            path="/:domain/:theme/:thematique/:id"
            element={<Orientation data={domainData} steps={stepsAlert} />}
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
